import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute1 = ({
  width = 140,
  height = 177,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 198,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 140 177"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M33.9997,110.999C25.7361,75.0287 23.6525,46.4684 41.4999,34.9992C81.3088,9.41687 132.706,82.0983 169.5,113.999"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M33.9997,110.999C25.7361,75.0287 23.6525,46.4684 41.4999,34.9992C81.3088,9.41687 132.706,82.0983 169.5,113.999"
      />

      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M35.43 114.836C35.3691 115.058 35.0899 115.132 34.9274 114.967L30.4601 110.453C30.2977 110.289 30.3738 110.011 30.5972 109.952L36.7401 108.34C36.9635 108.282 37.1666 108.487 37.1056 108.71L35.43 114.836Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute1
